export default "__VITE_PUBLIC_ASSET__6a5c619c__"